import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React, { useRef, useState, useEffect } from 'react';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';
import useLockBodyScroll from 'react-use/lib/useLockBodyScroll';
import useClickAway from 'react-use/lib/useClickAway';
import ReactDOM from 'react-dom';
import { TimelineMax } from 'gsap/TweenMax';
import { config } from '../helpers/config';

var Modal = function Modal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      open = _ref.open,
      onOutsideModalClick = _ref.onOutsideModalClick,
      _onComplete = _ref.onComplete,
      onReverseComplete = _ref.onReverseComplete,
      onReverseStart = _ref.onReverseStart,
      _onStart = _ref.onStart,
      opts = _objectWithoutPropertiesLoose(_ref, ["children", "className", "size", "open", "onOutsideModalClick", "onComplete", "onReverseComplete", "onReverseStart", "onStart"]);

  var _useState = useState(open),
      renderModal = _useState[0],
      setRenderModal = _useState[1];

  var modalRef = useRef();
  var modalDialogRef = useRef();

  var openModal = function openModal() {
    var $modal = modalRef.current;
    if ($modal && $modal.timeline) $modal.timeline.play();
  };

  var closeModal = function closeModal() {
    var $modal = modalRef.current;
    if ($modal && $modal.timeline) $modal.timeline.reverse();
  };

  var handleOnReverseComplete = function handleOnReverseComplete() {
    setRenderModal(false);
  };

  var attachTimeline = function attachTimeline() {
    var $modal = modalRef.current;
    var $modalDialog = modalDialogRef.current;
    var forward = true;
    var lastTime = 0; // Attach timeline to each instance

    $modal.timeline = new TimelineMax({
      paused: !open,
      onStart: function onStart() {
        $modal.classList.add(config.classes.open);

        _onStart();
      },
      onUpdate: function onUpdate() {
        var newTime = $modal.timeline.time();

        if (forward && newTime < lastTime || !forward && newTime > lastTime) {
          forward = !forward;

          if (!forward) {
            onReverseStart();
            $modal.classList.remove(config.classes.open);
          }
        }

        lastTime = newTime;
      },
      onComplete: function onComplete() {
        // Focus on active modal for screen readers
        $modal.focus();

        _onComplete();
      },
      onReverseComplete: function onReverseComplete() {
        handleOnReverseComplete();
      }
    });
    $modal.timeline.set($modal, {
      display: 'block'
    }).to($modal, 0.25, {
      css: {
        opacity: 1
      }
    }).to($modalDialog, 0.25, {
      css: {
        opacity: 1,
        y: 0
      },
      ease: config.easingBounce
    });
  };

  useEffect(function () {
    if (open) {
      setRenderModal(true);
    }
  }, [open]);
  useUpdateEffect(function () {
    if (!open) {
      closeModal();
    }
  }, [open]);
  useUpdateEffect(function () {
    if (renderModal) {
      attachTimeline();
      openModal();
    } else {
      onReverseComplete();
    }
  }, [renderModal]);
  var modalClasses = cx('modal', {
    'modal--small': size === 'small',
    'modal--large': size === 'large'
  }, className);
  useClickAway(modalDialogRef, function () {
    return onOutsideModalClick();
  });
  useLockBodyScroll(renderModal);
  return renderModal && ReactDOM.createPortal(React.createElement("div", Object.assign({
    className: modalClasses,
    ref: modalRef
  }, opts), React.createElement("div", {
    className: "modal-dialog",
    ref: modalDialogRef
  }, children)), document.body);
};

Modal.defaultProps = {
  onOutsideModalClick: function onOutsideModalClick() {},
  onComplete: function onComplete() {},
  onReverseComplete: function onReverseComplete() {},
  onReverseStart: function onReverseStart() {},
  onStart: function onStart() {}
};
export default Modal;